import { z } from 'zod';
import { BaseAddressDTOSchema, } from "./addresses.dto.js";
import { CreateAddressInputDTOSchema } from "./create-address.dto.js";
// Service layer DTOs
export const UpdateAddressInputDTOSchema = CreateAddressInputDTOSchema.and(z.object({
    id: BaseAddressDTOSchema.shape.id,
}));
// API layer DTOs (if needed for direct address update endpoints)
export const UpdateAddressRequestDTOSchema = z.object({
    params: z.object({
        addressId: BaseAddressDTOSchema.shape.id,
    }),
    body: CreateAddressInputDTOSchema,
});
//# sourceMappingURL=update-address.dto.js.map